import { render, staticRenderFns } from "./FrequencyCreateTab.vue?vue&type=template&id=eb5abc12&scoped=true"
import script from "./FrequencyCreateTab.vue?vue&type=script&lang=js"
export * from "./FrequencyCreateTab.vue?vue&type=script&lang=js"
import style0 from "./FrequencyCreateTab.vue?vue&type=style&index=0&id=eb5abc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5abc12",
  null
  
)

export default component.exports